// Cookies
function setCookie(name, value, expiryDays) {
    var expires = "";
    if (expiryDays) {
      var date = new Date();
      date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
  function eraseCookie(name) {
    document.cookie = name + "=; Path=/; Expires=Fri, 01 Jan 1990 00:00:01 GMT;";
  }
  
  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      if(this.getAttribute("data-show-once") == "false") {
        document.documentElement.classList.add("disable-scroll");
      }
    
      if(this.getAttribute("data-block-click") !== "true") {
        this.addEventListener("click", this.onOverlayClick);
      }
  
      if(this.querySelector("#closeLink")) {
        this.querySelector("#closeLink").addEventListener("click", this.close.bind(this));
      }

      if(this.querySelector(".close-btn")) {
        this.querySelector(".close-btn").addEventListener("click", this.close.bind(this));
      }

      if (
        this.getAttribute("data-show-once") == "true" &&
        getCookie("popup-closed") !== "true" &&
        window.location.pathname !== "/challenge" &&
        window.location.pathname !== "/password"
      ) {
        setTimeout(
          () => this.show(),
          this.getAttribute("data-popup-delay") * 1000
        );
      }
    }
  
    close() {
      this.style.opacity = 0;
      this.style.display = "none";
      this.querySelector(".newsletter-popup").classList.remove(
        "newsletter-popup--loaded"
      );
      if (this.getAttribute("data-show-once") == "true") {
        setCookie(
          "popup-closed",
          "true",
          this.getAttribute("data-popup-frequency")
        );
      }
      document.documentElement.classList.remove("disable-scroll");
      this.showRewardsApp();
      this.remove();
    }
  
    show() {
      document.documentElement.classList.add("disable-scroll");
      
      this.style.opacity = 1;
      this.style.display = "block";
      this.querySelector(".newsletter-popup").classList.add(
        "newsletter-popup--loaded"
      );
    }
  
    onOverlayClick(event) {
      if (event.target == this) {
        this.close();
      }
    }

    showRewardsApp() {
      const rewardsWidget = document.getElementById("smile-ui-container");
      if(rewardsWidget) {
        rewardsWidget.style.opacity = "1";
      }
      const rewardsWidgetLite = document.getElementById("smile-ui-lite-container");
      if(rewardsWidgetLite) {
        rewardsWidgetLite.style.opacity = "1";
      }
      const tidioChat = document.getElementById("tidio-chat");
      if(tidioChat) {
        tidioChat.style.opacity = "1";
      }

      if(!rewardsWidget || !rewardsWidgetLite) {
        setTimeout(this.showRewardsApp, 1500);
      }
    }
  }
  
  customElements.define("newsletter-popup", NewsletterPopup);
  